import { render } from "./Home_component.vue?vue&type=template&id=3670d257&scoped=true"
import script from "./Home_component.vue?vue&type=script&lang=js"
export * from "./Home_component.vue?vue&type=script&lang=js"

import "./Home_component.vue?vue&type=style&index=0&id=3670d257&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3670d257"]])

export default __exports__